import { useState, useCallback } from 'react';
import { apiService } from '../services/ApiService';

interface PasswordData {
    oldPassword: string;
    newPassword: string;
    confirmNewPassword: string;
}

export const usePasswordChange = () => {
    const [passwordData, setPasswordData] = useState<PasswordData>({
        oldPassword: '',
        newPassword: '',
        confirmNewPassword: ''
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const handleChangePassword = useCallback(async (e: React.FormEvent) => {
        e.preventDefault();

        if (passwordData.newPassword !== passwordData.confirmNewPassword) {
            alert('Las contraseñas no coinciden');
            return;
        }

        try {
            setLoading(true);
            setError(null);

            await apiService.post('/auth/change-password', {
                old_password: passwordData.oldPassword,
                new_password: passwordData.newPassword
            });

            alert('Contraseña actualizada correctamente');
            setPasswordData({
                oldPassword: '',
                newPassword: '',
                confirmNewPassword: ''
            });
        } catch (err: any) {
            const errorMessage = err.response?.data?.message || 'Error al cambiar la contraseña';
            setError(errorMessage);
            alert(errorMessage);
        } finally {
            setLoading(false);
        }
    }, [passwordData]);

    return {
        passwordData,
        setPasswordData,
        loading,
        error,
        handleChangePassword
    };
};
